<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h3>Projektübersicht</h3>
</div>

<form class="row row-cols-lg-auto g-3 align-items-center">
    <div class="col-12">
        <label class="form-check-label">Typ</label>
    </div>
    <div class="col-12">
        <select class="form-control form-control-sm" name="id_region" [(ngModel)]="filter.type"
                (ngModelChange)="listProjects()" [class.is-filtered]="filter.type !== 'all'">
            <option value="all">Alle</option>
            <option value="project">Projekte</option>
            <option value="light">Projekte Light</option>
        </select>
    </div>
    <div class="col-12">
        <label class="form-check-label">Länderbereich</label>
    </div>
    <div class="col-12">
        <select class="form-control form-control-sm" name="id_region" [(ngModel)]="filter.id_region"
                (ngModelChange)="listProjects()" [class.is-filtered]="filter.id_region !== 'all'">
            <option value="all">Alle</option>
            <option *ngFor="let region of regions" [value]="region.id">Region {{ region.region }}
                ({{ region.countries }})
            </option>
        </select>
    </div>
    <div class="col-12">
        <label class="form-check-label">Länder</label>
    </div>
    <div class="col-12">
        <select class="form-control form-control-sm" name="id_country" [(ngModel)]="filter.id_country"
                (ngModelChange)="listProjects()" [class.is-filtered]="filter.id_country !== 'all'">
            <option value="all">Alle</option>
            <option *ngFor="let country of countries" [value]="country.short">{{ country.short }}</option>
        </select>
    </div>
    <div class="col-12">
        <label class="form-check-label">Abteilung</label>
    </div>
    <div class="col-12">
        <select class="form-control form-control-sm" name="id_department" [(ngModel)]="filter.id_department"
                (ngModelChange)="listProjects()" [class.is-filtered]="filter.id_department !== 'all'">
            <option value="all">Alle</option>
            <option *ngFor="let department of departments" [value]="department.id">{{ department.name }}
                ({{ department.lead }})
            </option>
        </select>
    </div>
    <div class="col-12">
        <label class="form-check-label">Strategische Zuordnung</label>
    </div>
    <div>
        <select class="form-control form-control-sm" name="strategic_classification_root"
                [(ngModel)]="filter.strategic_classification_root"
                (ngModelChange)="listProjects()"
        >
            <option value="all">Alle</option>
            <option *ngFor="let classification of strategicClassifications" [ngValue]="classification">
                {{ classification.name }}
            </option>
        </select>
    </div>
    <div class="col-12">
        <select class="form-control form-control-sm" name="strategic_classification"
                [(ngModel)]="filter.strategic_classification"
                *ngIf="filter.strategic_classification_root !== 'all'"
                (ngModelChange)="listProjects()"
        >
            <option value="all">Alle</option>
            <option *ngFor="let sub of filter.strategic_classification_root.subs" [ngValue]="sub">
                {{ sub }}
            </option>
        </select>
    </div>
</form>

<table class="table table-sm table-hover">
    <thead>
    <tr>
        <th colspan="3"></th>
        <th [colSpan]="year.quarters.length" *ngFor="let year of years" style="text-align: center">{{ year.year }}</th>
    </tr>
    <tr>
        <th>Nummer</th>
        <th style="width: 40%">Projekt</th>
        <th style="width: 90px">Start</th>
        <th style="width: 90px">Ende</th>
        <ng-container *ngFor="let year of years">
            <th *ngFor="let quarter of year.quarters">Quartal {{ quarter }}</th>
        </ng-container>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let project of projects">
        <td>
            <ng-container *ngIf="project.type === 'light'">PRL{{ project.number | number: '3.0' }}</ng-container>
            <ng-container *ngIf="project.type === 'project'">{{ project.number }}</ng-container>
        </td>
        <td>
            <a *ngIf="project.type === 'project'" [routerLink]="['/project/detail', project.id]">{{ project.title }}</a>
            <a *ngIf="project.type === 'light'" [routerLink]="['/light/detail', project.id]">{{ project.title }}</a>
        </td>
        <td>{{ project.start | date: 'dd.MM.yyyy' }}</td>
        <td>{{ project.end | date: 'dd.MM.yyyy' }}</td>
        <td colspan="4" style="position: relative">
            <div class="progress" role="progressbar" [style.margin-left]="project.startPercent + '%'"
                 [style.margin-right]="project.endPercent + '%'" style="height: 21px">
                <div class="progress-bar" [class.bg-danger]="project.outdated" [class.bg-success]="project.type === 'light'" style="width: 100%"></div>
            </div>
            <div class="todayline" [style.left]="todayLineStart + '%'"></div>
        </td>
    </tr>
    </tbody>
</table>
